import React, { useCallback, useState } from "react";
import { Button, Body2 } from "@activecollab/components";
import { useLinkContext } from "~/components/LinkProvider/context";
import AddStripeCardDialog from "~/components/Subscription/BillingPaymentMethod/AddStripeCardDialog";
import { showSuccessToast } from "~/components/Toast";

const SubscriptionExpiredCardInfoBlock = () => {
  const [showStripe, setShowStripe] = useState(false);
  const { liveSupportQueryData } = useLinkContext();
  const queryParams = liveSupportQueryData ? `?${liveSupportQueryData}` : "";
  const url = `https://activecollab.com/help${queryParams}`;

  const closeStripe = useCallback(() => {
    setShowStripe(false);
  }, []);

  const changePaymentMethod = useCallback(() => {
    setShowStripe(true);
  }, []);

  const submitStripe = useCallback(() => {
    setShowStripe(false);
    showSuccessToast("Payment details updated.");
  }, []);

  return (
    <>
      <Body2>
        Your credit card has expired. Please enter a valid payment method!{" "}
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="activity-link"
        >
          Contact our Support Team
        </a>{" "}
        if you need further assistance.
      </Body2>
      <div className="tw-mt-6">
        <Button
          onClick={changePaymentMethod}
          className="tw-mr-3"
        >
          Change Payment Method
        </Button>
      </div>
      <AddStripeCardDialog
        open={showStripe}
        onSubmit={submitStripe}
        onClose={closeStripe}
      />
    </>
  );
};

export default SubscriptionExpiredCardInfoBlock;
